export * from '../../state/f2f/selectors';



/** WEBPACK FOOTER **
 ** ./src/members/__shared__/selectors/f2f.js
 **/